import { render } from "./MembersListCompact.vue?vue&type=template&id=495fc338&scoped=true"
import script from "./MembersListCompact.vue?vue&type=script&lang=js"
export * from "./MembersListCompact.vue?vue&type=script&lang=js"

import "./MembersListCompact.vue?vue&type=style&index=0&id=495fc338&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495fc338"]])

export default __exports__